import React, { Component } from 'react';

class IconAddBlueBorder extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
                <circle cx="10" cy="10" r="7.5" fill="#26A" stroke="#fff"></circle>
                <path fill="#fff" fillRule="evenodd" d="M10 5a.833.833 0 00-.833.833v3.334H5.833a.833.833 0 000 1.666h3.334v3.334a.833.833 0 001.666 0v-3.334h3.334a.833.833 0 000-1.666h-3.334V5.833A.833.833 0 0010 5z"
                    clipRule="evenodd">
                </path>
            </svg>
        );
    }
}

export default IconAddBlueBorder;